import React, {
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { useNavigate } from "react-router-dom";

import {
  AppBar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Stack,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
  Tooltip,
  Tabs,
  Tab,
} from "@mui/material";
import clsx from "clsx";
import { makeStyles, styled } from "@mui/styles";
import {
  DateFromEditorComponent,
  DateToEditorComponent,
} from "../../../discount-master/DatepickerEditorComponent";
import jwtDecode from "jwt-decode";
import dayjs from "dayjs";
import AgGridTable from "../../../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import ListPageHeader from "../../../utilities/ListPageHeader";
import { confirmAlert } from "react-confirm-alert";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { toast } from "react-toastify";
import { grey } from "@mui/material/colors";
import AsyncSelect from "react-select/async";
import { LinearProgress } from "@material-ui/core";
import moment from "moment";
import CustomDatePicker from "../../../utilities/CustomDatePicker";
import FormPageHeader from "../../../utilities/FormPageHeader";
import PaidBy from "./PaidBy";
import "../../expense-claim/expenseClaim.css";

const useStyles = makeStyles((theme) => ({
  root: {
    "& li": {
      padding: "5px 10px",
      cursor: "pointer",

      "&:hover": {
        backgroundColor: grey[800],
      },
    },
    // borderRadius: "20px",
    fontSize: "11px",
    textAlign: "center",
    height: "26px",
    lineHeight: "26px",
    padding: "0px 10px",
    marginTop: "6px",
  },
}));

const currentDate = new Date();

const ActionRenderer = (props) => {
  return (
    <div className="flex item-center">
      <Button color="warning" variant="contained" sx={{ mr: 1 }}>
        Pay
      </Button>
      <Button color="warning" variant="contained">
        {" "}
        View
      </Button>
    </div>
  );
};

export default function Loans(props) {
  const navigate = useNavigate();
  const classes = useStyles(props);

  const [payGroupOptions, setPayGroupOptions] = useState([
    { label: "All", value: "All" },
    { label: "Nolte FZE", value: "Nolte FZE" },
    { label: "Free Lance", value: "Free Lance" },
    { label: "IT Consulant", value: "IT Consulant" },
  ]);

  const [rowOpen, setRowOpen] = useState(false);

  const statusOptions = [
    { label: "All", value: "All" },
    { label: "Active", value: "Active" },
    { label: "Completed", value: "Completed" },
  ];

  const [rowData, setRowData] = useState([
    {
      fileNo: "1",
      description: "Receipt",
      fileType: "PDF",
      filePath: "D:/container_info.txt",
    },
    {
      fileNo: "2",
      description: "Receipts",
      fileType: "PDF",
      filePath: "D:/container_info.txt",
    },
  ]);

  const gridRef = useRef();

  const [totalClaimed, setTotalClaimed] = useState();
  const [docUpdate, setDocUpdate] = useState(false);
  const [initialState, setInitialState] = useState({
    docNo: null,
    docDate: currentDate,
    creationDate: new Date().toISOString(),
    employeeId: null,
    employeeName: null,
    companyCode: 1,
    companyName: "Nolte FZE",
    remark: null,
    folder: [],
  });

  const [tabValue, setTabValue] = useState("nolte");
  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Employee",
      children: [
        { field: "code", headerName: "Code" },
        { field: "fullName", headerName: "Full Name" },
        { field: "loanType", headerName: "Loan Type" },
        { field: "loanAgainst", headerName: "Loan Against" },
      ],
    },
    {
      headerName: "Request Initiated",
      children: [
        { field: "amount", headerName: "Amount" },
        { field: "date", headerName: "Date" },
      ],
    },
    {
      headerName: "Approved Loan Amount",
      children: [
        { field: "amount", headerName: "Amount" },
        { field: "date", headerName: "Date" },
      ],
    },
    {
      headerName: "Paid by NFZE",
      children: [
        { field: "amount", headerName: "Amount" },
        { field: "date", headerName: "Date" },
      ],
    },
    {
      field: "balanceLoanAmount",
      headerName: "Balance Loan Amount",
    },
    {
      field: "pbe",
      headerName: "Paid by Employee till date",
    },

    { field: "outstanding", headerName: "Outstanding" },
    { field: "status", headerName: "Status" },
  ]);

  const token = jwtDecode(localStorage.getItem("token"));

  console.log(token.scope);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const loadData = async () => {
    let email = token.email;
    const userDataUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByEmailIgnoreCase?email=${email}`;
    const result = await OAuthService.getList(userDataUrl);
    const user = result?.data;
    const empId = user?._links.user.href.split("/").pop();

    setInitialState({
      ...initialState,
      employeeName: user?.userName,
      employeeId: empId,
      companyName: user?.companyName,
      companyCode: user?.companyId,
    });
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    setDocUpdate(urlParams.get("id") === null ? false : true);
    if (urlParams.get("id") !== null) {
      const dataUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${
        oAuthServiceConfig.expenseClaimList
      }/${urlParams.get("id")}`;

      const dataVal = await OAuthService.getList(dataUrl);
      let amount = dataVal?.data?.recordList?.map((item) => {
        return item.amount;
      });
      setTotalClaimed(amount);
      setInitialState(dataVal.data);
      // setRowData(dataVal.data.recordList);
    }
  };

  const onGridReady = useCallback((params) => {
    loadData();
  }, []);

  const onBtDeleteRow = useCallback(
    (event) => {
      const selectedRow = [event.node.data];

      confirmAlert({
        title: "Confirm to cancel payment",
        message: "Are you sure to cancel payment ?",
        buttons: [
          {
            label: "Yes",
            onClick: () => {},
          },
          {
            label: "No",
            onClick: () => {},
          },
        ],
      });
    },
    [gridRef, rowData]
  );
  const getContextMenuItems = useCallback((event) => {
    const result = [
      {
        name: "Edit",
        icon: '<span><i class="material-icons style="font-size: 18px">edit</i></span>',
        action: () => {
          navigate("/loans/revision");
        },
      },
      {
        name: "Cancel",
        icon: '<span><i class="material-icons" style="font-size: 18px">cancel</i></span>',
        action: () => {
          onBtDeleteRow(event);
        },
      },
    ];
    return result;
  }, []);

  const handleTabChange = (event, value) => setTabValue(value);

  const onRowDoubleClicked = (params) => {
    handleRowDialogOpen();
  };
  const handleRowDialogOpen = () => {
    setRowOpen(!rowOpen);
  };

  return (
    <>
      <FormPageHeader
        componentName="Salaries"
        pageName={"Loans & Advances"}
        currentPage={"Loans & Advances"}
      />

      <Dialog open={rowOpen} fullWidth maxWidth="sm" component="form">
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              PAID BY NFZE
            </Typography>
            <IconButton onClick={handleRowDialogOpen}>
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-16 pb-0 sm:p-24 sm:pb-0" }}>
          <PaidBy />
        </DialogContent>
      </Dialog>

      <div className="p-4 sm:px-24">
        <Grid container spacing={2} className="items-center">
          <Grid xs={16} item>
            <Stack direction="row" spacing={2}>
              <Stack>
                <label>Employee Name</label>
                <TextField
                  className="mb-4 w-[120px]"
                  type="text"
                  required
                  variant="outlined"
                  fullWidth
                />
              </Stack>
              <Stack>
                <span>Date From</span>
                <CustomDatePicker
                  className="mb-4 w-[160px]"
                  format={"dd-MM-yyyy"}
                  name={"fromDate"}
                />
              </Stack>
              <Stack>
                <label>Date To</label>
                <CustomDatePicker
                  className="mb-4 w-[150px]"
                  name={"creationDate"}
                  format={"dd-MM-yyyy"}
                  fullWidth
                />
              </Stack>
              <Stack className="mr-16">
                <label>Pay Group</label>

                <Select
                  className="w-[150px]"
                  name="pay_group"
                  defaultValue={payGroupOptions[0]}
                  options={payGroupOptions}
                  styles={customStyles()}
                />
              </Stack>
              <Stack className="mr-16">
                <label>Status</label>

                <Select
                  className="w-[150px]"
                  name="status"
                  defaultValue={statusOptions[0]}
                  options={statusOptions}
                  styles={customStyles()}
                />
              </Stack>
              <div className="mt-16 flex items-end">
                <Button
                  color="warning"
                  variant="contained"
                  startIcon={
                    <FuseSvgIcon size={18}>
                      heroicons-outline:search
                    </FuseSvgIcon>
                  }
                  sx={{ mr: 1 }}
                />
                <Button
                  color="warning"
                  variant="contained"
                  startIcon={
                    <FuseSvgIcon size={18}>
                      heroicons-outline:plus-circle
                    </FuseSvgIcon>
                  }
                  onClick={() => {
                    navigate("/loans/request");
                  }}
                >
                  Loan
                </Button>
              </div>
            </Stack>
          </Grid>
        </Grid>
      </div>

      <div className="h-full">
      <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1" }}
          className={clsx(classes.root)}
        >
          <Tab 
            label="NOLTE FZE" 
            value={"nolte"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          <Tab 
            label="FREE LANCE" 
            value={"free-lance"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          <Tab 
            label="IT CONSULTANT" 
            value={"it-consultant"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
        </Tabs>

        <AgGridTable
          hideCheckbox={true}
          rowData={rowData}
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          gridRef={gridRef}
          onRowDoubleClicked={onRowDoubleClicked}
          getContextMenuItems={getContextMenuItems}
        />
      </div>
    </>
  );
}
